import { jwtDecode } from 'jwt-decode';
import { encryptStorage } from 'src/config/encrypt-storage';
import api, { apiForRefresh } from 'src/config/api';
import { TokenPayload } from 'src/types/login';

export const getCorrectToken = () => ({
  accessToken: encryptStorage.getItem('accessToken'),
  refreshToken: encryptStorage.getItem('refreshToken'),
});

export const setTokens = (accessToken, refreshToken) => {
  const { sessionId } = jwtDecode<TokenPayload>(refreshToken || accessToken);
  encryptStorage.setItem('sessionId', sessionId);
  encryptStorage.setItem('accessToken', accessToken);
  encryptStorage.setItem('refreshToken', refreshToken);
  api.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  apiForRefresh.defaults.headers.common.Authorization = `Bearer ${refreshToken}`;
};

export const removeTokens = () => {
  encryptStorage.removeItem('accessToken');
  encryptStorage.removeItem('refreshToken');
  encryptStorage.removeItem('sessionId');
  delete api.defaults.headers.common.Authorization;
  delete apiForRefresh.defaults.headers.common.Authorization;
};

export const getDecodedToken = () => {
  const { accessToken } = getCorrectToken();
  return jwtDecode<TokenPayload>(accessToken!);
};
